import { useRef, useState } from "react";

const CORNERS = [0, 2, 4, 6];

export const CornerEditor = ({ src, points, onChange }) => {
  const ref = useRef(null);
  const [drag, setDrag] = useState(null);

  const move = (e) => {
    if (drag == null) return;
    const r = ref.current.getBoundingClientRect();
    const x = Math.min(Math.max((e.clientX - r.left) / r.width, 0), 1);
    const y = Math.min(Math.max((e.clientY - r.top) / r.height, 0), 1);
    const [dx, dy] = [x - points[drag][0], y - points[drag][1]];
    const near = CORNERS.includes(drag) ? [(drag + 7) % 8, drag + 1] : [];
    const r4 = (v) => Number(Math.min(Math.max(v, 0), 1).toFixed(4));
    onChange(points.map(([px, py], i) => (i === drag ? [r4(x), r4(y)] : near.includes(i) ? [r4(px + dx / 2), r4(py + dy / 2)] : [px, py])));
  };
  const path = points.map(([x, y], i) => `${i ? "L" : "M"}${x * 100} ${y * 100}`).join(" ") + " Z";

  return (
    <div ref={ref} data-testid="corner-editor" className="relative select-none touch-none w-full"
      onPointerMove={move} onPointerUp={() => setDrag(null)} onPointerLeave={() => setDrag(null)}>
      <img src={src} alt="" draggable={false} className="w-full block rounded-md" />
      <svg viewBox="0 0 100 100" preserveAspectRatio="none" className="absolute inset-0 w-full h-full pointer-events-none">
        <path d={path} fill="rgba(16,185,129,0.15)" stroke="#10b981" strokeWidth="0.5" vectorEffect="non-scaling-stroke" style={{ strokeWidth: 2 }} />
      </svg>
      {points.map(([x, y], i) => (
        <div key={i} data-testid={`corner-handle-${i}`} onPointerDown={(e) => { e.preventDefault(); setDrag(i); }}
          className={`absolute -translate-x-1/2 -translate-y-1/2 rounded-full border-2 border-white shadow cursor-grab touch-none ${CORNERS.includes(i) ? "w-5 h-5 bg-emerald-600" : "w-4 h-4 bg-sky-500"} ${drag === i ? "scale-125" : ""}`}
          style={{ left: `${x * 100}%`, top: `${y * 100}%` }} />
      ))}
    </div>
  );
};
